import React, { useState } from 'react';
import { EnhancedProductCard } from '../shared/EnhancedProductCard';
import { AwardIcon, ChevronLeftIcon, ChevronRightIcon, SparklesIcon } from 'lucide-react';
import { useHorizontalScroll } from '../../lib/hooks/useHorizontalScroll';
export function BrandDeals() {
  const [selectedBrand, setSelectedBrand] = useState('optimum');
  const {
    scrollContainerRef
  } = useHorizontalScroll();
  const brands = [{
    id: 'optimum',
    name: 'Sensodyne',
    logo: 'https://img.innovapharmacy.com/media/catalog/category/284.png',
    description: 'Sensitive care essentials',
    discount: 'Up to 40% off'
  }, {
    id: 'muscletech',
    name: 'Pampers',
    logo: 'https://img.innovapharmacy.com/media/catalog/category/317.png',
    description: 'Care for every little moment',
    discount: 'Up to 35% off'
  }, {
    id: 'bsn',
    name: 'La Roche-Posay',
    logo: 'https://img.innovapharmacy.com/media/catalog/category/360.png',
    description: 'Dermatological skin care',
    discount: 'Up to 38% off'
  }, {
    id: 'dymatize',
    name: 'BabyJoy',
    logo: 'https://img.innovapharmacy.com/media/catalog/category/365.png',
    description: 'Gentle baby essentials',
    discount: 'Up to 42% off'
  }, {
    id: 'k18',
    name: 'K18',
    logo: 'https://img.innovapharmacy.com/media/catalog/category/369.png',
    description: 'Biomimetic hair science',
    discount: 'Up to 30% off'
  }, {
    id: 'argan-blends',
    name: 'Argan Blends',
    logo: 'https://img.innovapharmacy.com/media/catalog/category/401.png',
    description: 'Pure & natural care',
    discount: 'Up to 30% off'
  }];
  const brandProducts = {
    optimum: [{
      id: 1,
      name: 'Gold Standard 100% Whey',
      brand: 'Optimum Nutrition',
      price: 89.99,
      originalPrice: 149.99,
      discount: 40,
      rating: 4.9,
      reviewCount: 1245,
      image: 'https://img.innovapharmacy.com/media/catalog/product/4/5/4537b3e3-4206-41fc-b34e-53ddce591f66_1.jpg',
      isBestSeller: true
    }, {
      id: 2,
      name: 'Amino Energy',
      brand: 'Optimum Nutrition',
      price: 44.99,
      originalPrice: 74.99,
      discount: 40,
      rating: 4.7,
      reviewCount: 856,
      image: 'https://img.innovapharmacy.com/media/catalog/product/1/0/1015683_1.jpg'
    }, {
      id: 3,
      name: 'Serious Mass',
      brand: 'Optimum Nutrition',
      price: 79.99,
      originalPrice: 129.99,
      discount: 38,
      rating: 4.6,
      reviewCount: 634,
      image: 'https://img.innovapharmacy.com/media/catalog/product/2/1/213099.jpg'
    }, {
      id: 4,
      name: 'Creatine Powder',
      brand: 'Optimum Nutrition',
      price: 34.99,
      originalPrice: 54.99,
      discount: 36,
      rating: 4.8,
      reviewCount: 423,
      image: 'https://img.innovapharmacy.com/media/catalog/product/1/0/1030868_1.png'
    }, {
      id: 5,
      name: 'Gold Standard Pre-Workout',
      brand: 'Optimum Nutrition',
      price: 49.99,
      originalPrice: 79.99,
      discount: 38,
      rating: 4.5,
      reviewCount: 567,
      image: 'https://img.innovapharmacy.com/media/catalog/product/1/0/1000157_1.jpg'
    }, {
      id: 6,
      name: 'BCAA 1000 Caps',
      brand: 'Optimum Nutrition',
      price: 39.99,
      originalPrice: 64.99,
      discount: 38,
      rating: 4.4,
      reviewCount: 389,
      image: 'https://img.innovapharmacy.com/media/catalog/product/4/5/4537b3e3-4206-41fc-b34e-53ddce591f66_1.jpg'
    }],
    muscletech: [{
      id: 7,
      name: 'Nitro-Tech Whey Gold',
      brand: 'MuscleTech',
      price: 84.99,
      originalPrice: 139.99,
      discount: 39,
      rating: 4.8,
      reviewCount: 923,
      image: 'https://img.innovapharmacy.com/media/catalog/product/1/0/1015683_1.jpg'
    }, {
      id: 8,
      name: 'Cell-Tech Creatine',
      brand: 'MuscleTech',
      price: 54.99,
      originalPrice: 89.99,
      discount: 39,
      rating: 4.7,
      reviewCount: 712,
      image: 'https://img.innovapharmacy.com/media/catalog/product/2/1/213099.jpg'
    }, {
      id: 9,
      name: 'Vapor X5 Pre-Workout',
      brand: 'MuscleTech',
      price: 44.99,
      originalPrice: 74.99,
      discount: 40,
      rating: 4.6,
      reviewCount: 534,
      image: 'https://img.innovapharmacy.com/media/catalog/product/1/0/1030868_1.png'
    }, {
      id: 10,
      name: 'Amino Build',
      brand: 'MuscleTech',
      price: 39.99,
      originalPrice: 64.99,
      discount: 38,
      rating: 4.5,
      reviewCount: 445,
      image: 'https://img.innovapharmacy.com/media/catalog/product/1/0/1000157_1.jpg'
    }, {
      id: 11,
      name: 'Mass-Tech Extreme',
      brand: 'MuscleTech',
      price: 69.99,
      originalPrice: 114.99,
      discount: 39,
      rating: 4.4,
      reviewCount: 378,
      image: 'https://img.innovapharmacy.com/media/catalog/product/4/5/4537b3e3-4206-41fc-b34e-53ddce591f66_1.jpg'
    }, {
      id: 12,
      name: 'Hydroxycut Hardcore',
      brand: 'MuscleTech',
      price: 49.99,
      originalPrice: 79.99,
      discount: 38,
      rating: 4.3,
      reviewCount: 612,
      image: 'https://img.innovapharmacy.com/media/catalog/product/1/0/1015683_1.jpg'
    }],
    bsn: [{
      id: 13,
      name: 'Syntha-6 Protein',
      brand: 'BSN',
      price: 79.99,
      originalPrice: 129.99,
      discount: 38,
      rating: 4.8,
      reviewCount: 1034,
      image: 'https://img.innovapharmacy.com/media/catalog/product/2/1/213099.jpg'
    }, {
      id: 14,
      name: 'N.O.-XPLODE Pre-Workout',
      brand: 'BSN',
      price: 44.99,
      originalPrice: 74.99,
      discount: 40,
      rating: 4.7,
      reviewCount: 823,
      image: 'https://img.innovapharmacy.com/media/catalog/product/1/0/1030868_1.png'
    }, {
      id: 15,
      name: 'Amino X',
      brand: 'BSN',
      price: 39.99,
      originalPrice: 64.99,
      discount: 38,
      rating: 4.6,
      reviewCount: 567,
      image: 'https://img.innovapharmacy.com/media/catalog/product/1/0/1000157_1.jpg'
    }, {
      id: 16,
      name: 'True-Mass 1200',
      brand: 'BSN',
      price: 64.99,
      originalPrice: 104.99,
      discount: 38,
      rating: 4.5,
      reviewCount: 445,
      image: 'https://img.innovapharmacy.com/media/catalog/product/4/5/4537b3e3-4206-41fc-b34e-53ddce591f66_1.jpg'
    }, {
      id: 17,
      name: 'CellMass 2.0',
      brand: 'BSN',
      price: 49.99,
      originalPrice: 79.99,
      discount: 38,
      rating: 4.4,
      reviewCount: 389,
      image: 'https://img.innovapharmacy.com/media/catalog/product/1/0/1015683_1.jpg'
    }, {
      id: 18,
      name: 'Endorush Pre-Workout',
      brand: 'BSN',
      price: 42.99,
      originalPrice: 69.99,
      discount: 39,
      rating: 4.3,
      reviewCount: 312,
      image: 'https://img.innovapharmacy.com/media/catalog/product/2/1/213099.jpg'
    }],
    dymatize: [{
      id: 19,
      name: 'ISO100 Hydrolyzed',
      brand: 'Dymatize',
      price: 94.99,
      originalPrice: 149.99,
      discount: 37,
      rating: 4.9,
      reviewCount: 1156,
      image: 'https://img.innovapharmacy.com/media/catalog/product/1/0/1030868_1.png',
      isBestSeller: true
    }, {
      id: 20,
      name: 'Elite Whey Protein',
      brand: 'Dymatize',
      price: 74.99,
      originalPrice: 124.99,
      discount: 40,
      rating: 4.7,
      reviewCount: 834,
      image: 'https://img.innovapharmacy.com/media/catalog/product/1/0/1000157_1.jpg'
    }, {
      id: 21,
      name: 'Super Mass Gainer',
      brand: 'Dymatize',
      price: 64.99,
      originalPrice: 109.99,
      discount: 41,
      rating: 4.6,
      reviewCount: 623,
      image: 'https://img.innovapharmacy.com/media/catalog/product/4/5/4537b3e3-4206-41fc-b34e-53ddce591f66_1.jpg'
    }, {
      id: 22,
      name: 'Creatine Micronized',
      brand: 'Dymatize',
      price: 29.99,
      originalPrice: 49.99,
      discount: 40,
      rating: 4.8,
      reviewCount: 512,
      image: 'https://img.innovapharmacy.com/media/catalog/product/1/0/1015683_1.jpg'
    }, {
      id: 23,
      name: 'BCAA Complex 5050',
      brand: 'Dymatize',
      price: 39.99,
      originalPrice: 64.99,
      discount: 38,
      rating: 4.5,
      reviewCount: 445,
      image: 'https://img.innovapharmacy.com/media/catalog/product/2/1/213099.jpg'
    }, {
      id: 24,
      name: 'Pre W.O. Energy Boost',
      brand: 'Dymatize',
      price: 44.99,
      originalPrice: 74.99,
      discount: 40,
      rating: 4.4,
      reviewCount: 378,
      image: 'https://img.innovapharmacy.com/media/catalog/product/1/0/1030868_1.png'
    }]
  };
  const currentBrand = brands.find(brand => brand.id === selectedBrand) ?? brands[0];
  const selectedProducts = brandProducts[selectedBrand as keyof typeof brandProducts] ?? brandProducts.optimum;
  const scrollProducts = (direction: 'backward' | 'forward') => {
    scrollContainerRef.current?.scrollBy({
      left: direction === 'forward' ? 720 : -720,
      behavior: 'smooth'
    });
  };
  return <section className="container mx-auto px-4" aria-label="Brand exclusive deals" data-id="element-4273" data-mp="2tjb3iwtzwsxz">
      <div className="overflow-hidden rounded-xl border border-[#DCE9DE] bg-white" data-id="element-4274" data-mp="2xmqwnj6uwb5x">
        <header className="flex items-center justify-between border-b border-[#DCE9DE] bg-pharmacy-light px-4 py-4 md:px-6" data-id="element-4275" data-mp="2jmg2a66c8eg0">
          <div className="flex min-w-0 items-center gap-3" data-id="element-4276" data-mp="2olspwt519pjn">
            <div className="flex h-10 w-10 shrink-0 items-center justify-center rounded-lg bg-pharmacy text-white" data-id="element-4277" data-mp="3cau4yz8dfyxw">
              <AwardIcon className="h-5 w-5" aria-hidden="true" data-id="element-4278" data-mp="3h9ybfi3wvikj" />
            </div>
            <div data-id="element-4279" data-mp="32l23rm5ro7kg">
              <h2 className="text-xl font-bold text-gray-900 md:text-2xl" data-id="element-4280" data-mp="32lkajcq2246m">Brand Exclusive Deals</h2>
              <p className="hidden text-sm text-gray-600 sm:block" data-id="element-4281" data-mp="37j3rwli1ux2s">Exclusive savings from trusted brands</p>
            </div>
          </div>
          <div className="hidden items-center gap-2 md:flex" data-id="element-4282" data-mp="3v84ys4b8i05y">
            <button type="button" onClick={() => scrollProducts('backward')} className="flex h-9 w-9 items-center justify-center rounded-full border border-[#C8DDCB] bg-white text-pharmacy transition-colors duration-150 hover:bg-[#F6FBF7] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-pharmacy focus-visible:ring-offset-2" aria-label="Previous products" data-id="element-4283" data-mp="3vtwdooqjj0k">
              <ChevronLeftIcon className="h-5 w-5" aria-hidden="true" data-id="element-4284" data-mp="1te9zsce67tab" />
            </button>
            <button type="button" onClick={() => scrollProducts('forward')} className="flex h-9 w-9 items-center justify-center rounded-full border border-[#C8DDCB] bg-white text-pharmacy transition-colors duration-150 hover:bg-[#F6FBF7] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-pharmacy focus-visible:ring-offset-2" aria-label="Next products" data-id="element-4285" data-mp="15ofohz9i2cs6">
              <ChevronRightIcon className="h-5 w-5" aria-hidden="true" data-id="element-4286" data-mp="2l3lk1sxh8p2d" />
            </button>
          </div>
        </header>

        <div className="border-b border-gray-100 px-4 py-3 md:px-6" data-id="element-4287" data-mp="1iow1p0cit0w6">
          <div className="flex gap-2 overflow-x-auto pb-1 scrollbar-hide" data-id="element-4288" data-mp="1no8zgg4xjsdj">
            {brands.map(brand => {
            const isSelected = selectedBrand === brand.id;
            return <button key={brand.id} type="button" onClick={() => setSelectedBrand(brand.id)} aria-pressed={isSelected} className={`flex h-16 min-w-[108px] shrink-0 items-center justify-center rounded-lg border bg-white px-3 transition-[border-color,box-shadow] duration-150 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-pharmacy focus-visible:ring-offset-2 ${isSelected ? 'border-pharmacy ring-1 ring-pharmacy' : 'border-gray-200 hover:border-gray-300'}`} data-id="element-4289" data-mp="1wpyr9n2q4tbu">
                  <img src={brand.logo} alt={`${brand.name} logo`} className="max-h-10 max-w-[86px] object-contain" data-id="element-4290" data-mp="l7xczrxto7lb" />
                </button>;
          })}
          </div>
        </div>

        <div className="flex items-center justify-between px-4 pb-3 pt-4 md:px-6" data-id="element-4291" data-mp="3qrutdjupq1b">
          <div className="flex min-w-0 items-center gap-2" data-id="element-4292" data-mp="3vvub72xmg6ia">
            <SparklesIcon className="h-4 w-4 shrink-0 text-pharmacy" aria-hidden="true" data-id="element-4293" data-mp="3qxstomfugf8x" />
            <h3 className="truncate text-base font-bold text-gray-900 md:text-lg" data-id="element-4294" data-mp="3m6ub1g7dv52i">{currentBrand.name} offers</h3>
            <span className="hidden text-sm text-gray-600 sm:inline" data-id="element-4295" data-mp="3h6y69eqv39lw">— {currentBrand.description}</span>
          </div>
          <span className="ml-3 shrink-0 text-xs font-bold text-pharmacy" data-id="element-4296" data-mp="3c9fttedmyc95">{currentBrand.discount}</span>
        </div>

        <div ref={scrollContainerRef} className="flex snap-x snap-mandatory gap-3 overflow-x-auto px-4 pb-5 scrollbar-hide md:gap-4 md:px-6 md:pb-6" aria-label={`${currentBrand.name} product offers`} data-id="element-4297" data-mp="3869tend7ffal">
          {selectedProducts.map(product => <div key={`${selectedBrand}-${product.id}`} className="w-[44vw] max-w-[208px] shrink-0 snap-start md:w-[calc((100%_-_48px)_/_4)] md:max-w-[240px] lg:w-[calc((100%_-_80px)_/_6)]" data-id="element-4298" data-mp="1b4vkugnk47lh">
              <EnhancedProductCard product={{
            ...product,
            brand: currentBrand.name
          }} data-id="element-4299" data-mp="12bihekrv9nl5" />
            </div>)}
        </div>
      </div>
    </section>;
}